import React from 'react'

import { Navbar, Footer } from '../../../components';
import { Article10Doc } from '../individual';

export default function Article10() {
  return (
    <div className='emas__article10'>
        <Navbar />
        <Article10Doc />
        <Footer />
    </div>
  )
}
